const CATEGORY_LABELS = {
    fuel: "Fuel",
    fuel_request: "Fuel",
    fuel_report: "Fuel Report",
    catering: "Catering",
    catering_order: "Catering",
    catering_service: "Catering",
    hotac: "HOTAC",
    crew_transport: "Crew Transport",
    crew_transportation: "Crew Transport",
    maintenance: "Maintenance",
    ground_handling: "Ground Handling",
    permit_request: "Permit",
    flight_brief: "Flight Brief",
    crew_activation: "Crew Activation",
    general: "General",
    cpm: "CPM",
    ffm: "FFM",
    fwb: "FWB",
    mvt: "MVT",
    ucm: "UCM",
    hkg_cargo_attachment: "香港货运附件",
    post_flight_doc: "香港货运附件",
};

const WORD_LABEL_OVERRIDES = {
    aeg: "AEG",
    bja: "BJA",
    bud: "BUD",
    cgs: "CGS",
    cena: "CENA",
    cpm: "CPM",
    ffm: "FFM",
    fwb: "FWB",
    haeco: "HAECO",
    hkg: "HKG",
    hotac: "HOTAC",
    kgf: "KGF",
    mvt: "MVT",
    ucm: "UCM",
    vip: "VIP",
};

function isRecord(value) {
    return Boolean(value && typeof value === "object" && !Array.isArray(value));
}

function toRecord(value) {
    return isRecord(value) ? value : {};
}

function normalizeText(value, fallback = "") {
    if (value === null || value === undefined) return fallback;
    if (typeof value !== "string" && typeof value !== "number") return fallback;
    const normalized = String(value).replace(/\s+/g, " ").trim();
    return normalized || fallback;
}

function formatWord(value) {
    const text = normalizeText(value);
    if (!text) return "";
    const lower = text.toLowerCase();
    if (WORD_LABEL_OVERRIDES[lower]) return WORD_LABEL_OVERRIDES[lower];
    if (/^[A-Z0-9]{2,}$/.test(text)) return text;
    return `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;
}

function formatIdentifierLabel(value) {
    const text = normalizeText(value);
    if (!text) return "";
    return text
        .split(/[\s_-]+/)
        .map(formatWord)
        .filter(Boolean)
        .join(" ");
}

function formatConfidence(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return "";
    const percentage = number > 1 ? number : number * 100;
    return `${Math.round(Math.max(0, Math.min(percentage, 100)))}%`;
}

function buildEmptyClassificationDisplay() {
    return {
        visible: false,
        category: "",
        subCategory: "",
        categoryLabel: "",
        subCategoryLabel: "",
        supplierName: "",
        confidenceText: "",
        label: "",
        codeLabel: "",
    };
}

export function buildMailClassificationDisplay(classification) {
    if (classification === null || classification === undefined) {
        return buildEmptyClassificationDisplay();
    }

    const record = toRecord(classification);
    const category = normalizeText(record.category).toLowerCase();
    if (!category) {
        return buildEmptyClassificationDisplay();
    }

    const subCategory = normalizeText(record.sub_category || record.subCategory).toLowerCase();
    const metadata = toRecord(record.metadata);
    const categoryLabel = CATEGORY_LABELS[category] || formatIdentifierLabel(category);
    const subCategoryLabel = formatIdentifierLabel(subCategory);

    return {
        visible: true,
        category,
        subCategory,
        categoryLabel,
        subCategoryLabel,
        supplierName: normalizeText(record.supplier_name || record.supplierName || metadata.supplier_name || metadata.supplierName),
        confidenceText: formatConfidence(record.confidence),
        label: subCategoryLabel ? `${categoryLabel} · ${subCategoryLabel}` : categoryLabel,
        codeLabel: subCategory ? `${category} / ${subCategory}` : category,
    };
}
